import http from '@/utils/http';

// 评量工具使用次数
export const getScaleTotal = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/scale/all',
        method: 'get',
        params
    })
}
//  热门评量工具
export const getScaleRank = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/scale',
        params
    })
}
// 各学校教育平台资源使用情况
export const getSchooltNums = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/school/resource',
        params
    })
}
// IEP制定总数
export const getIEPTotal = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/iep/all',
        params
    })
}
// 教案总数
export const getPlanTotal = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/coursePlan/all',
        params
    })
}
